const API = process.env.REACT_APP_BACKEND_URL;

export const adminFetch = async (path, { method = "GET", body } = {}) => {
  const res = await fetch(`${API}${path}`, {
    method, credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.detail || `Request failed (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return data;
};

export const money = (c) => (c == null ? "—" : `$${(c / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
export const when = (iso) => (iso ? new Date(iso).toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" }) : "—");

export const STATUS_LABELS = { pending_payment: "Pending Payment", paid: "Paid", processing: "Processing", shipped: "Shipped", completed: "Completed", cancelled: "Cancelled", refunded: "Refunded" };
export const ADMIN_STATUSES = ["paid", "processing", "shipped", "completed", "cancelled", "refunded"];
export const CARRIERS = ["FedEx", "UPS", "USPS", "Freight / LTL", "Other"];
export const STATUS_TONE = { pending_payment: "text-yellow-300 border-yellow-300/40", paid: "text-emerald-300 border-emerald-300/40", processing: "text-sky-300 border-sky-300/40", shipped: "text-indigo-300 border-indigo-300/40", completed: "text-gray-300 border-gray-400/40", cancelled: "text-gray-500 border-gray-500/40", refunded: "text-orange-300 border-orange-300/40" };
